/**
 * SIDC E-Collect Core
 * Our Endpoints are powered by .Net Core, Onion Architecture, CQRS with MediatR Library,Entity Framework Core - Code First,Repository Pattern - Generic, Swagger UI, API Versioning,Fluent Validation and Automapper.
 *
 * OpenAPI spec version: v1
 * Contact: sidcmisdepartment@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreateLoanDetailsCommand { 
    memberCode?: string;
    principal?: number;
    interest?: number;
    penalties?: number;
    serviceFee?: number;
    notarialFee?: number;
    miscellaneousIncome?: number;
    total?: number;
    promiseToPayDate?: Date;
    remarks?: string;
    branchId?: number;
    loanTypeId?: number;
    collectorUserName?: string;
    loanStatusId?: number;
}